var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"wrapper-www"}},[_c('b-container',{attrs:{"fluid":""}},[_c('app-header'),_c('menu-main'),_c('menu-main-sm'),(!_vm.isValidTenant)?_c('app-content-error'):_c('app-content'),_c('app-footer')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }